class GallerySliderComponent extends SliderComponent {
  constructor() {
    super();
    if (!this.slider || !this.nextButton) return;

    this.setInitialSlidePosition();
    this.onWindowLoad = this.setInitialSlidePosition.bind(this);
    this.onPageShow = event => {
      if (event.persisted) this.setInitialSlidePosition();
    };
    window.addEventListener('load', this.onWindowLoad, { once: true });
    window.addEventListener('pageshow', this.onPageShow);
    
    this.sliderControlWrapper = this.querySelector('.slider-buttons');

    if (!this.sliderControlWrapper) return;
    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (!this.sliderItemsToShow.length) return;
    if (this.sliderItemsToShow.length < 2) {
      this.sliderItemOffset = this.sliderItemsToShow[0].clientWidth;
      this.slidesPerPage = 1;
      this.totalPages = 1;
      this.update();
      return;
    }

    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    if (!this.sliderItemOffset) return;

    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset) || 1;
    this.totalPages = Math.max(this.sliderItemsToShow.length - this.slidesPerPage + 1, 1);
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    if (!this.sliderItemsToShow || !this.sliderItemsToShow.length) return;

    const previousPage = this.currentPage;
    this.currentPage = this.getNearestSlideIndex() + 1;
    this.currentPage = Math.min(Math.max(this.currentPage, 1), this.totalPages || 1);

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.currentPage <= 1) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage >= this.totalPages) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
    
    
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1] && (
      this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active'),
      this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true)
    )
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    const nextPage = event.currentTarget.name === 'next' ? this.currentPage + Number(step) : this.currentPage - Number(step);
    const targetPage = Math.min(Math.max(nextPage, 1), this.totalPages || 1);
    this.slideScrollPosition = this.sliderItemsToShow[targetPage - 1]?.offsetLeft ?? 0;
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
  
  linkToSlide(event) {
    event.preventDefault();
    const targetPage = this.sliderControlLinksArray.indexOf(event.currentTarget) + 1;
    const slideScrollPosition = this.sliderItemsToShow[targetPage - 1]?.offsetLeft ?? 0;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setInitialSlidePosition() {
    const firstSlideOffset = this.sliderItemsToShow?.[0]?.offsetLeft ?? 0;

    // Run an immediate sync pass to avoid Safari showing wrong controls before the first frame.
    this.slider.scrollLeft = firstSlideOffset;
    this.update();

    requestAnimationFrame(() => {
      this.slider.scrollLeft = firstSlideOffset;
      this.update();
      setTimeout(() => {
        this.slider.scrollLeft = firstSlideOffset;
        this.update();
      }, 120);
    });
  }

  getNearestSlideIndex() {
    const currentScroll = this.slider.scrollLeft;
    let nearestIndex = 0;
    let nearestDistance = Infinity;

    this.sliderItemsToShow.forEach((slide, index) => {
      const distance = Math.abs(slide.offsetLeft - currentScroll);
      if (distance < nearestDistance) {
        nearestDistance = distance;
        nearestIndex = index;
      }
    });

    return nearestIndex;
  }

  disconnectedCallback() {
    if (this.onWindowLoad) window.removeEventListener('load', this.onWindowLoad);
    if (this.onPageShow) window.removeEventListener('pageshow', this.onPageShow);
  }
}

customElements.define('slider-gallery-component', GallerySliderComponent);
